import React, { useState } from 'react'
import { formatTime } from '../../utils/time.utils'

import styles from '../../styles/components/partner/invoice.module.css'


function Invoice({invoice, refresh=()=>{}}) {
    return (
        <div className={styles.main}>
            <div>{invoice?.emergent && "IS TECH"} {invoice?.amount} ₴</div>
            <div>{invoice?.cardNumber}</div>
            <div>{invoice?.clientId}</div>
            <div>{invoice?._id}</div>
            <div className={`${styles.status} ${invoice?.status}`}>{invoice?.status}</div>
            <div className={styles.date}>
                {formatTime(invoice?.createdAt).replaceAll(',', " ")}
            </div>
        </div>
      )
}

export default Invoice